import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { purchasesRoute } from './routes';
import { EmptyPurchasesError } from './lib/error';
import { EmptyPurchases } from './components/EmptyPurchases/EmptyPurchases';
import { purchasesSelectionWidget } from './widgets';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: purchasesRoute,
        meta: {
            plusPaymentPage: 'Purchases',
            page: 'purchases',
        },
        component: lazy(() => import('./components/Purchases/Purchases')),
        fallback: RouteSkeleton,
    });

    ctx.addError({
        is: (error) => error instanceof EmptyPurchasesError,
        component: EmptyPurchases,
    });

    ctx.addWidget({
        widget: purchasesSelectionWidget,
        component: lazy(() => import('./components/PurchasesSelection/PurchasesSelection')),
    });
});

export * from './routes';

export default scenario;
